import styled from 'styled-components';

export const ReceiptTableContainer = styled('div')`
  width: 100%;
  height: fit-content;
  margin-top: 20px;
  overflow: hidden;

  .MuiTableContainer-root {
    height: 100%;
    overflow: auto;
    width: 100%;
  }
  @media only screen and (max-width: 1024px) {
    width: 100%;
    overflow: hidden;
    padding: 0 10px;
  }
`;
